import type { KetchConsentData } from './ketch-types';

// TEMPORARY hardcoded list, manually populated from
// https://app.eu.ketch.com/privacy-program/jurisdictions
// Opt-out jurisdictions are commented out but listed for completeness
// example: https://app.eu.ketch.com/privacy-program/jurisdictions/view/gdpr/purposes
//
// This is a stopgap until jurisdiction classification can be sourced
// dynamically from Ketch (e.g. via getConsentConfig()/getFullConfig())
// instead of duplicated here. If Ketch adds/changes a jurisdiction's
// opt-in/opt-out status, this list needs to be updated manually to match.
const KETCH_OPT_IN_JURISDICTIONS = [
  // 'default' // Global Standard // Consent - Opt Out
  // 'australia' // Australia // Consent - Opt Out
  'lgpd', // Brazil // Consent - Opt In
  'Canada', // Canada // Consent - Opt In
  'pipl', // China & Hong Kong // Consent - Opt In
  'gdpr', // European Economic Area // Consent - Opt In
  'dpdp', // India // Consent - Opt In
  'israel', // Israel // Consent - Opt In
  'jamaica', // Jamaica // Consent - Opt In
  'appi', // Japan // Consent - Opt In
  'korea', // Korea // Consent - Opt In
  'Quebec', // Quebec // Consent - Opt In
  'singapore', // Singapore // Consent - Opt In
  'uruguay', // Uruguay // Consent - Opt In
  // 'US_California' // US - California // Consent - Opt Out
  // 'US_Colorado' // US - Colorado // Consent - Opt Out
  // 'US_Connecticut' // US - Connecticut // Consent - Opt Out
  // 'US_Delaware' // US - Delaware // Consent - Opt Out
  // 'US_General' // US General // Consent - Opt Out
  // 'US_Indiana' // US - Indiana // Consent - Opt Out
  // 'US_Iowa' // US - Iowa // Consent - Opt Out
  // 'US_Kentucky' // US - Kentucky // Consent - Opt Out
  // 'US_Maryland' // US - Maryland // Consent - Opt Out
  // 'US_Montana' // US - Montana // Consent - Opt Out
  // 'US_Nebraska' // US - Nebraska // Consent - Opt Out
  // 'US_Nevada' // US - Nevada // Consent - Opt Out
  // 'US_NewHampshire' // US - New Hampshire // Consent - Opt Out
  // 'US_NewJersey' // US - New Jersey // Consent - Opt Out
  // 'US_Oregon' // US - Oregon // Consent - Opt Out
  // 'US_Rhode_Island' // US - Rhode Island // Consent - Opt Out
  // 'US_Texas' // US - Texas // Consent - Opt Out
  // 'US_Utah' // US - Utah // Consent - Opt Out
  // 'US_Virginia' // US - Virginia // Consent - Opt Out
];

/**
 * Checks whether a Ketch consent record's jurisdiction is one that requires
 * opt-in consent (as opposed to an opt-out regime, or no applicable
 * jurisdiction at all).
 *
 * @param consent - Ketch consent data (or null if no cookie)
 * @returns true if the consent's jurisdiction is an opt-in jurisdiction
 */
export const isOptInJurisdiction = (
  consent: KetchConsentData | null,
): boolean => {
  const jurisdiction = consent?.jurisdiction?.toUpperCase();
  if (!jurisdiction) {
    return false;
  }

  return KETCH_OPT_IN_JURISDICTIONS.some(
    (optInJurisdiction) => optInJurisdiction.toUpperCase() === jurisdiction,
  );
};
